/**
 * The operating-calendar route table (design §5.9).
 *
 * Split across two prefixes on purpose. `/settings/operating-calendars` is
 * configuration — the working week, the holidays, the shifts — set up once and
 * changed rarely. `/operations/day-board` is the screen somebody works every
 * evening. They are different jobs done by different people, and putting the
 * holiday editor one click from the nightly close is how a calendar gets edited
 * by accident at 11pm.
 *
 * Both are gated on read permissions; opening, closing and reopening a day are
 * checked on the action.
 */

import type { RouteRecordRaw } from 'vue-router'

import { OPCAL_PERMISSIONS } from '@/modules/opcal/permissions'

export const OPCAL_ROUTES: RouteRecordRaw[] = [
  {
    path: '/operations/day-board',
    name: 'opcal-day-board',
    component: () => import('@/modules/opcal/BusinessDayBoard.vue'),
    meta: { titleKey: 'opcal.routeTitles.board', permission: OPCAL_PERMISSIONS.dayRead },
  },
  {
    path: '/settings/operating-calendars',
    name: 'opcal-calendars',
    component: () => import('@/modules/opcal/CalendarsView.vue'),
    meta: { titleKey: 'opcal.routeTitles.calendars', permission: OPCAL_PERMISSIONS.calendarRead },
  },
  {
    path: '/settings/operating-calendars/:id(\\d+)',
    name: 'opcal-calendar',
    component: () => import('@/modules/opcal/CalendarEditor.vue'),
    meta: { titleKey: 'opcal.routeTitles.calendar', permission: OPCAL_PERMISSIONS.calendarRead },
  },
]
